import {CommonIadlXlsxDataProcessor} from '../export-care-plan-common-iadl-xlsx-data';

export class EscortXlsxDataProcessor extends CommonIadlXlsxDataProcessor {
  // Inherits the same headers and row structure as Common processor.
}
